import React from 'react';

import UniversalNavLink from '../UniversalNavLink';
import { isLinkSelected } from './utils';

import type { UniversalNavLinkType } from '../../constants';

type InAppLinksProps = {
  isCollapsed: boolean;
  links: Array<UniversalNavLinkType>;
  selectedHref: string;
};

const InAppLinks = ({ isCollapsed, links, selectedHref }: InAppLinksProps) => {
  return (
    <React.Fragment>
      {links?.map((link: UniversalNavLinkType) => {
        const isSelected = isLinkSelected(link.href || '', selectedHref);

        let icon = link.icon;
        if (typeof icon === 'object') {
          if (isSelected) {
            icon = icon.selected;
          } else {
            icon = icon.unselected;
          }
        }

        return (
          <li key={link.text}>
            <UniversalNavLink
              href={link.href}
              icon={icon}
              isCollapsed={isCollapsed}
              isSelected={isSelected}
              isSidebar={true}
              text={link.text}
            />
          </li>
        );
      })}
    </React.Fragment>
  );
};

export default InAppLinks;
